import { makeAutoObservable } from 'mobx'
import { uiStore } from 'shared/store/uiStore'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { CompliancePath } from 'pages/settings/pages/compliance/route/compliancePath'
import { TollFreeAddNumberRoutesSteps } from 'pages/settings/pages/compliance/pages/tollFree/route/type'

const titleMap: Record<string, string> = {
  [TollFreeAddNumberRoutesSteps.AssignNumber]: 'Assign number',
  [TollFreeAddNumberRoutesSteps.ChooseNumber]: 'Choose number',
  [TollFreeAddNumberRoutesSteps.Payment]: 'Payment',
}

export class TollFreeAddNumberNavigationStore {
  private _currentStep = 1

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  setCurrentStep = (step: number) => {
    this._currentStep = step
  }

  getStep = (direction: -1 | 1 | 0) => {
    const allSteps = Object.values(this.stepMap)
    const currentPageIndex = this._currentStep - 1

    return allSteps[currentPageIndex + direction]
  }

  getStepByPath = (tollFreeRoutes: TollFreeAddNumberRoutesSteps) => {
    const allPaths = Object.entries(this.stepMap)
    const stepIndex = allPaths.findIndex((path) => {
      return path[1] === tollFreeRoutes
    })

    return stepIndex !== -1 ? stepIndex + 1 : 1
  }

  getStepUrlMap = (tollFreeRoutes: TollFreeAddNumberRoutesSteps) => {
    return `${this.rootPath}/${tollFreeRoutes}`
  }

  get rootPath() {
    return CompliancePath.compliance.tollFree.addNumber
  }

  get stepMap() {
    return {
      1: TollFreeAddNumberRoutesSteps.ChooseNumber,
      2: TollFreeAddNumberRoutesSteps.AssignNumber,
      3: TollFreeAddNumberRoutesSteps.Payment,
    }
  }

  get getCurrentStep() {
    return this.getStep(0)
  }

  get getNextStep() {
    const step = this.getStep(1)

    if (!step) return this.getCurrentStep

    return step
  }

  get getLastStep() {
    const step = this.getStep(-1)

    if (!step) return this.getCurrentStep

    return step
  }

  get getCurrentUrl() {
    return `${this.rootPath}/${this.getCurrentStep}`
  }

  get getNextUrl() {
    return `${this.rootPath}/${this.getNextStep}`
  }

  get getLastUrl() {
    return `${this.rootPath}/${this.getLastStep}`
  }

  get allStepsLength() {
    return Object.keys(this.stepMap).length
  }

  get tollFreeNumbers() {
    return this._entities.numbersStore.tollFreeNumbers
  }

  decreaseStep = () => {
    uiStore.changeRoute({
      path: this.getLastUrl,
    })
  }

  getSettingsStep = (path: TollFreeAddNumberRoutesSteps) => {
    return this.getStepByPath(path)
  }

  getProgressInfoTitle = (pathname: string) => {
    return titleMap[pathname] || ''
  }
}
